import React, { memo, useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import FormControl from '../../components/form/FormControl'
import Footer from '../../components/ui/Footer'
import FormSelect from '../../components/form/FormSelect'
import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore'
import app, { db } from '../../firebase'
import { useAuth } from '../../contexts/AuthContext'
import { createSearchParams, Link, useLocation, useNavigate } from 'react-router-dom'
import EFFECT from 'vanta/dist/vanta.clouds.min.js'
import * as THREE from "three"; // Importing THREE.js
import Logo from '../../components/ui/Logo'
import Header from '../../components/ui/Header'

const AppointmentManagement = () => {

    /** Appointment Form
     * 
     * Resposibility:
     * 
     * Capture user data and send to Firestore DB
     * 
     * Params:
     * 
     * Appointment Datetime
     * UserId
     * Service Selected
     * Created Date
     */

   
    const { currentUser, userId, userRole } = useAuth();
    const [appointments, setAppointments] = useState([]);
    const [appointmentCards, setAppointmentCards] = useState();

    const collectionName = "Appointments";

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [vantaEffect, setVantaEffect] = useState(null)
    const myRef = useRef(null)
     
    

    useEffect(() => {
        if(!currentUser){
            navigate({
                pathname: '/login',
                search: createSearchParams({
                    path: location.pathname
                }).toString()
            })
        }
    }, [])

    useEffect(() => {
        

        const getUserAppointments = async () => {

            const appointmentsQuery = query(collection(db, collectionName), where("uid", "==", userId))
            const querySnapshot = await getDocs(appointmentsQuery);

            setAppointments([]);
            querySnapshot.forEach((doc) => {
                setAppointments((prev) => [...prev, {id: doc.id, 
                    start_date: new Date(doc.data().start.seconds * 1000).toString(), 
                    ...doc.data()
                }])
            })   
        }

        const getAllAppointments = async () => {

            const data = await getDocs(collection(db, collectionName));
            setAppointments(data.docs.map((doc) => 
                ({ ...doc.data(), 
                    start_date: new Date(doc.data().start.seconds * 1000).toString(),
                    id: doc.id})));  
        }

        if(userRole === "Regular")
            getUserAppointments();

        if(userRole === "Admin")
            getAllAppointments();

    }, [userId]);
    
    const handleDeleteAppointment = async (appointment) => {     
        if(window.confirm('Are you sure you want to delete your ' + appointment.title + ' appointment?')){
            await deleteDoc(doc(db, collectionName, appointment.id));
            window.location.reload();
        }
    }

  return (
    <div>
        <Header>
            <h2 className='text-center text-dark thick-font sub-header-txt-shadow'>{userRole === "Admin" ? 'Appointment Management'
            : 'Your Appointments'} </h2>
        </Header>
        <Container>
            <Row className='justify-content-center'>
                <Link to={"/appointment-management/create-appointment"} type="button" className={'btn text-white btn-secondary w-25 my-4'}>Add New Appointment</Link>
            </Row>
            <Row>
                {appointments.length < 1 ? <span className='display-1 my-3'>No Appointments Found</span> : <></>}
                {appointments.map((appointment) => {
                    return (<Col key={appointment.id}>
                                <Card className='event-card mb-3'>
                                    <Card.Header>
                                        <Card.Title>{appointment && appointment.service && appointment.service.display_name}</Card.Title>
                                    </Card.Header>
                                    <Card.Body>
                                        <Card.Text>{appointment && appointment.service && appointment.service.description}</Card.Text>
                                        <Card.Text>Booked For: {appointment.start_date}</Card.Text> 

                                        {userRole === 'Admin' ? 
                                        <Card.Text>
                                            Booked By: {appointment.user.displayName} ({appointment.user.email})
                                        </Card.Text> : <></>}
                                        <Link className={'btn btn-warning mb-3'} to={'/appointment-management/create-appointment/' + appointment.id}>Edit</Link>
                                        <Button onClick={() => handleDeleteAppointment(appointment)} type="button" className={'btn btn-danger mb-3 mx-3'}>Delete</Button>
                                    </Card.Body>
                                </Card>
                            </Col>)
                })} 
            </Row>
        </Container>
        <Footer></Footer>
</div>       
  )
}

export default memo(AppointmentManagement);
